import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {Dialog} from '@angular/cdk/dialog';

@Component({
  selector: 'pas-yes-no',
  standalone: true,
  imports: [
    MatIcon,
    MatButton
  ],
  templateUrl: './yes-no.component.html',
  styleUrl: './yes-no.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YesNoComponent {
  data = inject(MAT_DIALOG_DATA)
  dialogRef = inject(MatDialogRef<YesNoComponent>);
}
